import React from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import ReportFooter from "../../screens/common/ReportFooter";
import ReportHeader from "../../screens/common/ReportHeader";
import ReactToPrint from "react-to-print";
import "./viewqr.css";
import $ from "jquery";
import CustomerInfoTable from "../../screens/common/CustomerInfoTable";
import { configuration } from "../../appConfig";
import axios from "axios";
import CustomerInfoTable_swiss from "../../screens/common/CustomerInfoTable_swiss";
import CustomerInfoTable_newswiss from "../../screens/common/CustomerInfoTable_newswiss";
import ReportFooter_Swiss from "../../screens/common/ReportFooter_Swiss";
import ReportHeader_Swiss from "../../screens/common/ReportHeader_Swiss";
const partnerId = localStorage.getItem("partnerId");
const vin = localStorage.getItem("selectedFile");

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export default class OldQR extends React.Component {
  state = {
    qrDetails: {},
    lang: "",
    words: {},
  };
  async componentDidMount() {
    const { qrDetails } = this.state;
    // <script type="text/javascript">
    this.getLang();
    await this.getQRDetails();
  }
  CreateQR = () => {
    const { qrDetails } = this.state;
    var query = {
      cht: "qr",
      choe: "UTF-8",
      chs: "900x900",
      chld: "30",
      chl: `estimateID=${qrDetails.estimateId || '""'};vin=${qrDetails.vin || '""'};regno=${qrDetails.reg || '""'};make=${qrDetails.make || '""'};model=${qrDetails.model || '""'};color=${qrDetails.color || '""'}`
    };
    var url = "https://chart.apis.google.com/chart?" + $.param(query);
    $("#link").attr("src", url);
  };
  getQRDetails = () => {
    let url =
      configuration.getSingleQRDetails +
      "?partnerId=" +
      partnerId +
      "&vin=" +
      vin +
      "&qr_type=" +
      0;
    axios
      .get(url)
      .then((res) => {
        if (res.data.data.length) {
          this.setState(
            {
              qrDetails: res.data.data[0],
            }
          );
        }
      })
      .catch((err) => console.log(err))
      .finally(() => this.CreateQR())
  };
  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    let currentLang;
    if (lang === "fr") {
      currentLang = "ch-fr";
    } else {
      currentLang = lang;
    }
    return words[word] ? words[word][currentLang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else if (nextProps.Authorized !== prevState.Authorized) {
      prevState.fullData.Authorized = nextProps.Authorized;
      return {
        Authorized: nextProps.Authorized,
      };
    } else return null;
  }
  render() {
    const client = localStorage.getItem("client")
    const { qrDetails } = this.state;
    return (
      <>
        <div className="animated fadeIn">
          <div xs="12" sm="12" className="p-2">
            {/* <Card>
              <CardHeader>
                <ReactToPrint
                  trigger={() => {
                    document.title = localStorage.getItem("selectedFile");
                    return (
                      <button className="glass btn btn-lg btn-danger pull-right">
                        <i className="fa fa-print" />
                        &nbsp; {this.lang("Print PDF")}
                      </button>
                    );
                  }}
                  content={() => this.componentRef}
                />
                <small>
                  {" "}
                  {this.lang("VIN Number")} :{" "}
                  {localStorage.getItem("selectedFile")}
                </small>
              </CardHeader>
            </Card> */}
            <Card className="print_button_card mt-2">
              <CardHeader>
                  <div  className="container-fluid">
                  <div className="row align-items-center p-0">
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt-sm-10">
                      <small> {client === "SWISS" || client === "POLAND" ?<span>{this.lang("DashboardVIN")} : </span> : <span>{this.lang("VIN Number")} : </span>} {localStorage.getItem("selectedFile")}</small>
                      </div>
                      <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                      <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      <ReactToPrint
                          trigger={() =>
                          {
                          document.title = localStorage.getItem("selectedFile");
                          return (
                          <button className="glass btn btn-lg btn-danger pull-right">
                          <i className="fa fa-print" />
                          &nbsp; {this.lang("Print PDF")}
                          </button>
                          );
                          }}
                          content={() => this.componentRef}
                          />
                      </div>
                      </div>
                  </div>
                  </div>
              </CardHeader>
          </Card>
            <div
              className="container reportmini all-reports-top-wrapper"
              // id="divIdToPrint"
              ref={(el) => (this.componentRef = el)}
              style={{ padding: 0 }}
            >
              <div id="front-page-card" className="row row-zero page-break-row report-full-wrapper">
                <div className="col-sm-12 main-col-full">
                  <Card>
                    <CardBody className="p-0">
                      <div className="newFormatReport">
                      {localStorage.getItem('client') === 'SWISS' ? 
                        <ReportHeader_Swiss is_view_qr_page={true} /> 
                        :
                        <ReportHeader_Swiss is_view_qr_page={true} />
                        }
                        <div
                          className="text-center mt-5 p-3"
                        >
                          <img
                            // id="link"
                            src={`data:image/png;base64,${qrDetails.qr_base64}`}
                            className="m-auto"
                            style={{ width: "85%" }}
                          />
                          {localStorage.getItem("client") === "SWISS" ? (
                            <CustomerInfoTable_swiss />
                          ) :
                          localStorage.getItem('partnerId') === '20-220515' ? (
                            <CustomerInfoTable_newswiss />
                          )
                          :
                          (
                            <CustomerInfoTable />
                          )}
                        </div>
                      </div>
                    </CardBody>
                    {localStorage.getItem('client') === 'SWISS' ? 
                    <ReportFooter_Swiss pageNo={1}/>
                    :
                    <ReportFooter_Swiss />
                    }
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
